import { InputTextarea, InputTextareaProps } from 'primereact/inputtextarea';
import { withFormControl } from '../with-form-control';

export const FormInputTextarea = withFormControl<InputTextareaProps>((props) => {
  return <InputTextarea {...props} />;
});
